export const ADD_PRODUCTS = 'ADD_PRODUCTS';
export const RESET_PRODUCTS_STATE = 'RESET_PRODUCTS_STATE';
export const ADD_FILTERS = 'ADD_FILTERS';
export const ADD_IMAGES = 'ADD_IMAGES';
export const ADD_POPULAR_PRODUCTS = 'ADD_POPULAR_PRODUCTS';